import { Navigate, useLocation } from "react-router-dom";
import { useAuth, homeFor } from "../../context/AuthContext";
import { Loader } from "../common/States";

export default function ProtectedRoute({ need = "user", children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loader label="Vérification de la session…" />;
  if (user === false) return <Navigate to={`/connexion?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (need === "platform" && !user.platform_role) return <Navigate to={homeFor(user)} replace />;
  if (need === "company" && !user.memberships?.length) return <Navigate to={homeFor(user)} replace />;
  return children;
}
